var map = {
	"./amazon.svg": "d320",
	"./anghami.png": "9292",
	"./apple.svg": "a427",
	"./boomplay.jpg": "57f6",
	"./deezer.svg": "bba6",
	"./itunes.svg": "0942",
	"./napster.svg": "1bd7",
	"./pandora.svg": "c45d",
	"./spotify.svg": "3430",
	"./tidal.svg": "5f57",
	"./youtube.svg": "b64a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b23a";